/**
 * Returns the first day of the current month.
 * Updates once a month.
 * Examples:
 * - Any day in January: "YYYY-01-01"
 * - Any day in February: "YYYY-02-01"
 */
export const getUpdatedDate = (): string => {
  const today = new Date();

  // Get the first day of the current month
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  return firstDayOfMonth.toLocaleDateString('sv-SE');
};

export const getUpdatedDateLabel = (): string => {
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  return firstDayOfMonth.toLocaleDateString('sv-SE', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const getCurrentYear = (): number => new Date().getFullYear();

const swedishShortDateFormatter = new Intl.DateTimeFormat("sv-SE", {
  day: "numeric",
  month: "short",
  year: "numeric",
});

const swedishLongDateFormatter = new Intl.DateTimeFormat("sv-SE", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

export const formatSwedishShortDate = (date: string | number | Date): string =>
  swedishShortDateFormatter.format(new Date(date));

export const formatSwedishLongDate = (date: string | number | Date): string =>
  swedishLongDateFormatter.format(new Date(date));
